module.exports = __webpack_public_path__ + "img/city.800f9984.png";